import React, { useContext } from 'react';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import { InformeMovimientosActivosContext } from '.';

export default function GraficoAsignacionesTipoRecurso() {

  const { dataGraficoAsignacionesTipoRecurso } = useContext(InformeMovimientosActivosContext);

  return (
    <HighchartsReact
      highcharts={Highcharts}
      options={{
        chart: {
          type: 'pie',
        },
        title: {
          text: "Composición según tipo de recurso"
        },
        legend: {
          layout: 'vertical',
          align: 'right',
          verticalAlign: 'bottom',
          borderWidth: 1,

        },
        tooltip: {
          pointFormat: '{series.name}: <b>{point.y:.1f}</b>'
        },
        series: [{
          dataLabels: {
            enabled: true,
            format: '{point.percentage:.1f}%',
            distance: -30,
            filter: {
              property: 'percentage',
              operator: '>',
              value: 4
            }
          },
          showInLegend: true,
          minPointSize: 10,
          zMin: 0,
          data: dataGraficoAsignacionesTipoRecurso
        }]
      }}
    />);
}